<div class="main-wrapper">
	<div class="main-content">
		<!-- global markup for header -->
		<header class="header">
			<div class="content">
				<div class="header__block row">
					<div class="header__arrow col image" (click)="BackToDohot()"><img src="/assets/images/header/back-arrow.svg" alt="arrow" /><span style="color: white; font-size: 18px">חזרה</span></div>
					<div class="header__title col">{{ _text.store.barcodeDefinitionsManagement }}</div>
					<div class="header__burger col image">
						<!-- <img src="/assets/images/header/burger.svg" alt="burger"> -->
					</div>
				</div>
			</div>

			<!-- <h2 style="text-align: center" *ngIf="LoadingBack === true">טוען אנא המתן</h2> -->
		</header>

		<section class="report-table" style="margin-top: 40px">
			<div class="content">
				<div style="display: flex; justify-content: space-between; align-items: center">
					<div class="product-detail__button flex justify-align-center" (click)="openNewBarcodeProductDrawer()">הגדרה חדשה</div>
				</div>

				<div class="report-table__row report-table__row_between"></div>

				<div class="report-table__row report-table__row_full-width">
					<div class="loading" *ngIf="loading">
						<mat-spinner color="primary"></mat-spinner>
					</div>
					<mat-progress-bar *ngIf="isLoadingProgressBarShowing" style="position: absolute" mode="indeterminate"></mat-progress-bar>
					<ng-container *ngIf="definitionsDisplay$ | async as definitions">
						<table class="report-table__table" cellspacing="0" *ngIf="definitions.length && !loading; else noDataBlock" dir="rtl">
							<thead class="report-table__table-head">
								<tr>
									<th class="report-table__table-head-name">ברקוד</th>
									<th class="report-table__table-head-name">מק"ט</th>
									<th class="report-table__table-head-name">כמות</th>
									<th class="report-table__table-head-name">תוקף</th>
									<th class="report-table__table-head-name">אריזות</th>
									<th class="report-table__table-head-name">פעולות</th>
								</tr>
							</thead>
							<tbody class="report-table__table-body">
								<tr *ngFor="let def of definitions">
									<td class="report-table__table-body-name">{{ def.Id }} - {{ def.BarcodeName }} ({{ def.BarcodeLen }})</td>
									<td class="report-table__table-body-name">{{ def.MakatLoc }} - {{ def.MakatLoc + def.MakatLen - 1 }}</td>
									<td class="report-table__table-body-name">
										<ng-container *ngIf="def.hasQuantity; else noTableDataBlock"> {{ def.QtyLoc || '' }} - {{ def.QtyLoc + def.QtyLen - 1 || '' }} </ng-container>
									</td>
									<td class="report-table__table-body-name">
										<ng-container *ngIf="def.hasTokef; else noTableDataBlock">
											{{ def.TokefDay || '' }}/{{ def.TokefMonth || '' }}/{{ def.TokefYear || '' }}-{{ def.TokefYear + def.YearSegment || '' }}
										</ng-container>
									</td>
									<td class="report-table__table-body-name">
										<ng-container *ngIf="def.hasPackQuantity; else noTableDataBlock">
											{{ def.PackIdLoc }} - {{ def.PackIdLoc + def.PackIdLen - 1 }} / {{ def.PackQTY }} / {{ def.PackageSug }}
										</ng-container>
									</td>

									<td class="report-table__table-body-name bold text-align-center">
										<div class="flex gap">
											<button mat-raised-button (click)="handleEditProductBarcode(def)">ערוך</button>
											<button mat-raised-button color="primary" (click)="handleChangeBarcodeDefinition($event, def.Id, 'delete')">מחק</button>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</ng-container>

					<ng-template #noDataBlock>
						<h1>אין נתונים להציג</h1>
					</ng-template>
					<ng-template #noTableDataBlock> ללא </ng-template>
					<!-- <h1 *ngIf="FilterLoading === false && !allSpecials.length">אין נתונים להציג</h1> -->
				</div>
			</div>
		</section>
	</div>
</div>

<!-- markup for sort popup -->
<div class="popup" *ngIf="productBarcodeDrawerOpen">
	<div class="overlay"></div>
	<div class="report-table-popup report-table-popup_sort popup__content">
		<div class="popup__close" (click)="closeDrawer()"></div>
		<div class="report-table-popup__header">
			<div class="report-table-popup__header-search"></div>
			<div class="report-table-popup__header-title">{{ isEdittingBarcodeDefinition ? 'עריכת הגדרה' : 'הגדרה חדשה' }}</div>
		</div>
		<div class="report-table-popup__wrapper">
			<div class="report-table-popup__content">
				<div class="loading" *ngIf="loading; else formBlock">
					<mat-spinner color="primary"></mat-spinner>
					<h3 style="text-align: center; direction: rtl">טוען...</h3>
				</div>
				<ng-template #formBlock>
					<div class="report-table-popup__row report-table-popup__row_no-border report-table-popup__row_double">
						<div *ngIf="updateSuccess; else alertChangeBlock" style="width: 100%; display: grid; place-items: center">
							<h3 style="text-align: center; color: var(--valid-color)">הגדרה {{ isEdittingBarcodeDefinition ? 'עודכנה' : 'נוספה' }} בהצלחה!</h3>
							<button mat-raised-button color="primary" (click)="closeDrawer()">סגור</button>
						</div>

						<ng-template #alertChangeBlock>
							<form [formGroup]="form" dir="rtl" autocomplete="off" class="flex flex-column gap" (ngSubmit)="handleFormSubmit()">
								<mat-form-field color="primary">
									<mat-label>שם</mat-label>
									<input matInput placeholder="שם" type="text" formControlName="BarcodeName" required />
									<mat-error>שדה חסר או אינו תקין</mat-error>
								</mat-form-field>
								<mat-form-field color="primary">
									<mat-label>אורך</mat-label>
									<input matInput placeholder="אורך" type="text" formControlName="BarcodeLen" inputmode="numeric" required />
									<mat-error>שדה חסר או אינו תקין</mat-error>
								</mat-form-field>
								<mat-form-field color="primary">
									<mat-label>מיקום מק"ט</mat-label>
									<input matInput placeholder='מיקום מק"ט' type="text" formControlName="MakatLoc" inputmode="numeric" required />
									<mat-error>שדה חסר או אינו תקין</mat-error>
								</mat-form-field>
								<mat-form-field color="primary">
									<mat-label>אורך מק"ט</mat-label>
									<input matInput placeholder='אורך מק"ט' type="text" formControlName="MakatLen" inputmode="numeric" required />
									<mat-error>שדה חסר או אינו תקין</mat-error>
								</mat-form-field>
								<mat-form-field color="primary">
									<mat-label>מיקום כמות</mat-label>
									<input matInput placeholder="מיקום כמות" type="text" formControlName="QtyLoc" inputmode="numeric" />
									<mat-error>שדה אינו תקין</mat-error>
								</mat-form-field>
								<mat-form-field color="primary">
									<mat-label>אורך כמות</mat-label>
									<input matInput placeholder="אורך כמות" type="text" formControlName="QtyLen" inputmode="numeric" />
									<mat-error>שדה אינו תקין</mat-error>
								</mat-form-field>
								<mat-form-field color="primary">
									<mat-label>מיקום כמות עשרונית</mat-label>
									<input matInput placeholder="מיקום כמות עשרונית" type="text" formControlName="QtyDot" inputmode="numeric" />
									<mat-error>שדה אינו תקין</mat-error>
								</mat-form-field>
								<mat-form-field color="primary">
									<mat-label>תוקף יום</mat-label>
									<input matInput placeholder="תוקף יום" type="text" formControlName="TokefDay" inputmode="numeric" />
									<mat-error>שדה אינו תקין</mat-error>
								</mat-form-field>
								<mat-form-field color="primary">
									<mat-label>תוקף חודש</mat-label>
									<input matInput placeholder="תוקף חודש" type="text" formControlName="TokefMonth" inputmode="numeric" />
									<mat-error>שדה אינו תקין</mat-error>
								</mat-form-field>

								<mat-form-field color="primary">
									<mat-label>תוקף שנה</mat-label>
									<input matInput placeholder="תוקף שנה" type="text" formControlName="TokefYear" inputmode="numeric" />
									<mat-error>שדה אינו תקין</mat-error>
								</mat-form-field>

								<mat-form-field color="primary">
									<mat-label>אורך שנה</mat-label>
									<input matInput placeholder="אורך שנה" type="text" formControlName="YearSegment" inputmode="numeric" />
									<mat-error>שדה אינו תקין</mat-error>
								</mat-form-field>
								<mat-form-field color="primary">
									<mat-label>מיקום מזהה אריזה</mat-label>
									<input matInput placeholder="מיקום מזהה אריזה" type="text" formControlName="PackIdLoc" inputmode="numeric" />
									<mat-error>שדה אינו תקין</mat-error>
								</mat-form-field>
								<mat-form-field color="primary">
									<mat-label>אורך מזהה אריזה</mat-label>
									<input matInput placeholder="אורך מזהה אריזה" type="text" formControlName="PackIdLen" inputmode="numeric" />
									<mat-error>שדה אינו תקין</mat-error>
								</mat-form-field>
								<mat-form-field color="primary">
									<mat-label>מספר אריזות</mat-label>
									<input matInput placeholder="מספר אריזות" type="text" formControlName="PackQTY" inputmode="numeric" />
									<mat-error>שדה אינו תקין</mat-error>
								</mat-form-field>
								<mat-form-field color="primary">
									<mat-label>סוג אריזה</mat-label>
									<input matInput placeholder="סוג אריזה" type="text" formControlName="PackageSug" inputmode="numeric" />
									<mat-error>שדה אינו תקין</mat-error>
								</mat-form-field>

								<div class="report-table-popup__button-wrapper" style="position: relative">
									<button class="report-table-popup__button" [ngClass]="{ darken: form.invalid }">{{ isEdittingBarcodeDefinition ? 'ערוך' : 'אשר' }}</button>
								</div>
							</form>
						</ng-template>
					</div>
				</ng-template>
			</div>
		</div>
	</div>
</div>
